import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { Loading } from '@/components/ui';

export function ProtectedRoute() {
  const { user, isInitialized } = useAuthStore();
  const location = useLocation();

  // Show loading only during initial auth state check
  if (!isInitialized) {
    return <Loading fullScreen message="読み込み中..." />;
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Redirect to verify email if email not verified
  if (!user.emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  return <Outlet />;
}
